import React, { useState, useEffect, FC } from "react";
import { Table, Button, Input, message } from "antd";
import { YHModal } from "@/components/YHModal";
import { ColumnsType } from "antd/lib/table";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { YhBox } from "@/components/YhBox";
import { YhBut } from "@/components/YhButton";
import { RouterParamType } from "@/model/navModel";
import { OPT_TYPE } from "@/types/AppEnums";
import { formatInt, formatNum } from "@/utils/utils";
import { useSupplierOfferModel } from "./supplierOfferModel";
import { IDtpMaterialDetail } from "../../../dtpTypes";
import { enquiryService } from "../../../dtpService";


export const MaterialDiolog: FC<RouterParamType> = ({ id, mode }) => {
    const { supplierMaterialDialog: visible, setSupplierMaterialDialog, insertMaterial } = useSupplierOfferModel(({ supplierMaterialDialog }) => [supplierMaterialDialog])
    //查询条件
    const [searchParam, setSearchParam] = useState<string>("");
    //列表数据源
    const [dataSource, setDataSource] = useState<IDtpMaterialDetail[]>([]);  //默认拿询价单的已保存并且未报价的商品  未报价的状态为0
    const [selectMaterial, setSelectMaterial] = useState<IDtpMaterialDetail[]>([]);

    //获取询价单已报价的商品
    const getDtpDetailList = async () => {
        let { retData } = await enquiryService.one(id);
        let { details, ...formVal } = retData;
        if (retData) {
            setDataSource(details?.map(item => ({ ...item, key: item.id ?? "" })).filter(item => !item.isOffer) ?? []);
        }
        return retData;
    };

    useEffect(() => {
        if (visible) {
            getDtpDetailList()
            setSelectMaterial([]);
        }
    }, [visible])

    const onCancel = () => {
        setSupplierMaterialDialog(false);
    };

    let loadData = async (searchParms?: string) => {
        let goodsList = [...dataSource];
        if (searchParms) {
            let reg = new RegExp(searchParms);
            let arr: IDtpMaterialDetail[] = [];
            goodsList.forEach(item => {
                if (item.materialCode?.match(reg) || item.materialName?.match(reg)) {
                    arr.push(item);
                }
            });
            setDataSource(arr)
            if (!arr.length) {
                message.warning("列表没有该商品");
            }
        } else {
            getDtpDetailList();
        }
    }

    const column = (optype: number) => [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            align: "center",
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: '商品编号',
            width: 140,
            dataIndex: 'materialCode',
            fixed: "left",
        }, {
            title: '商品名称',
            width: 160,
            dataIndex: 'materialName',
            fixed: "left",
            render: (text: string) => <p className="ellipsis" title={text}>{text}</p>
        }, {
            title: '商品名称-英文',
            width: 160,
            dataIndex: 'materialEname',
            fixed: "left",
            render: (text: string) => <p className="ellipsis" title={text}>{text}</p>
        }, {
            title: '商品类型',
            width: 160,
            dataIndex: 'typeName',
        }, {
            title: '规格型号',
            width: 100,
            dataIndex: 'model',
        },
        {
            title: '数量',
            width: 100,
            dataIndex: 'num',
            editable: optype === OPT_TYPE.ADD ? false : true,
        },
        optype === OPT_TYPE.ADD ? {} : {
            title: '单价',
            width: 100,
            dataIndex: 'price',
            editable: true,
        }, {
            title: '操作',
            width: 80,
            fixed: "right",
            align: "center",
            className: "td-wrap",
            render: (text: any, record: IDtpMaterialDetail) => optype === OPT_TYPE.ADD ?
                <YhBut
                    type="add"
                    txt="添加"
                    disabled={!!selectMaterial.find(item => item.id === record.id)}
                    click={() => {
                        //添加配件，  数量默认为0
                        setSelectMaterial(origin => [...origin, { ...record, num: record.num ?? 1, price: "1.00" }])
                    }}
                />
                :
                <YhBut
                    type="delete"
                    txt="删除"
                    click={() => {
                        //删除对应配件
                        setSelectMaterial(origin => origin.filter(item => item.id !== record.id))
                    }}
                />
        }
    ];

    const newSelectColumns = column(OPT_TYPE.REMOVE).map((col: any, index) => {
        return {
            ...col,
            onCell: (record: IDtpMaterialDetail, rowIndex: number) => ({
                colIndex: index,
                rowIndex,
                record,
                rules: col.rules,
                options: col.options,
                editType: col.editType,
                editable: col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑
    const handleSave = (row: IDtpMaterialDetail) => {
        row.num = +formatInt(row.num);
        row.price = +formatNum(row.price);
        let dataSource = [...selectMaterial];
        const index = dataSource.findIndex((item) => row.key === item.key);
        const item = dataSource[index];
        dataSource.splice(index, 1, { ...item, ...row });
        setSelectMaterial(dataSource);
    }

    const rightChildren = <div className="flex">
        <Input
            allowClear
            datatype="round"
            className="border-r-16"
            placeholder="商品编号/商品名称"
            value={searchParam}
            onChange={(e) => setSearchParam(e.target.value)}
            onPressEnter={() => loadData(searchParam)}
        />
        <Button style={{ margin: "0px 12px 0px 15px" }} shape="round" onClick={() => loadData(searchParam)}>检索</Button>
    </div >


    return <YHModal
        visible={visible}
        okText="确认添加"
        onOk={() => insertMaterial(selectMaterial)}
        onCancel={onCancel}
        title="供应商报价单--选择配件"
        width={1000}
        bodyHeight={700}
        showFooter={true}
    >
        <YhBox title="待选配件列表" rightChildren={rightChildren} style={{ marginBottom: "5px", paddingBottom: 0 }}>
            <Table
                columns={column(OPT_TYPE.ADD) as ColumnsType<IDtpMaterialDetail>}
                dataSource={dataSource}
                pagination={{
                    position: ["bottomCenter"],
                    defaultPageSize: 10,
                    hideOnSinglePage: true,
                    showTotal: (total) => `共${total}条`,
                }}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
        <YhBox title="已选配件列表">
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newSelectColumns as ColumnsType<IDtpMaterialDetail>}
                dataSource={selectMaterial}
                pagination={false}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    </YHModal>
}